export default function StatCard({
  value,
  label,
  colour,
  icon,
  trend,
  onClick,
}) {
  return (
    <div
      onClick={onClick}
      style={{
        background: 'var(--color-bg-primary)',
        border: '0.5px solid var(--color-border-light)',
        borderRadius: 'var(--radius-lg)',
        padding: '16px 18px',
        cursor: onClick ? 'pointer' : 'default',
        transition: 'border-color 0.15s',
      }}
      onMouseEnter={e => onClick && (e.currentTarget.style.borderColor = 'var(--color-border-medium)')}
      onMouseLeave={e => onClick && (e.currentTarget.style.borderColor = 'var(--color-border-light)')}
    >
      <div style={{
        display: 'flex',
        alignItems: 'flex-start',
        justifyContent: 'space-between',
        marginBottom: 10,
      }}>
        <div style={{
          fontSize: 32,
          fontWeight: 'var(--font-weight-normal)',
          color: colour || 'var(--color-text-primary)',
          lineHeight: 1,
        }}>
          {value}
        </div>
        {icon && (
          <div style={{
            width: 32,
            height: 32,
            borderRadius: 'var(--radius-md)',
            background: (colour || 'var(--color-brand)') + '18',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flexShrink: 0,
          }}>
            {icon}
          </div>
        )}
      </div>
      <div style={{
        fontSize: 'var(--font-size-base)',
        color: 'var(--color-text-secondary)',
      }}>
        {label}
      </div>
      {trend !== undefined && (
        <div style={{
          fontSize: 'var(--font-size-sm)',
          color: trend >= 0 ? 'var(--color-success)' : 'var(--color-danger)',
          marginTop: 4,
        }}>
          {trend >= 0 ? '↑' : '↓'} {Math.abs(trend)}% vs last month
        </div>
      )}
    </div>
  );
}